import { withProperties } from "../../utils";
import createPingHandlerFactory from "./ping";

import {
  getChargeReference,
  getOrderReference,
  getTransactionReference,
  getChargeResponseCode,
  traverseDataFields
} from "./helpers";

function __validateResponseHandlerFactory__(options) {
  return createPingHandlerFactory(function __delegatedHandler__() {
    const { context, options } = this;
    const { onValidateFailed, onValidateSuccessful, onRequireValidation } = options;
    const { data } = context;

    // Augment the charge callback context with an object of references:
    // charge(flw_reference), order(order_reference), transaction(txref).
    withProperties(context, {
      reference: withProperties(Object.create(null), {
        charge: getChargeReference(data),
        order: getOrderReference(data),
        transaction: getTransactionReference(data)
      })
    });

    const { status, acctvalrespcode, responsecode } =
      traverseDataFields(data, 'status', 'acctvalrespcode', 'responsecode');

    const chargeCode = getChargeResponseCode(data);
    const chargeStatus = String(status).toLowerCase();
    const validationCode = responsecode || acctvalrespcode;

    if (
      ['00'].indexOf(validationCode) >= 0 ||
      ['00'].indexOf(chargeCode) >= 0 ||
      ['success', 'successful'].indexOf(chargeStatus) >= 0
    ) { return onValidateSuccessful.call(context) }

    const { authModel, responsemessage, acctvalrespmessage, chargeResponseMessage, message, paymentType } =
      traverseDataFields(
        data,
        'authModelUsed::authModel',
        'responsemessage',
        'acctvalrespmessage',
        'chargeResponseMessage',
        'message',
        'paymentType'
      );

    const validationMessage = responsemessage || acctvalrespmessage;

    // Augment context object with more properties
    withProperties(context, {
      auth: authModel || null,
      charge_code: chargeCode,
      payment_type: paymentType,
      validation_code: validationCode,
      message: withProperties(Object.create(null), {
        charge: chargeResponseMessage || null,
        validation: validationMessage || null,
        fallback: message || null
      })
    });

    if (chargeStatus.indexOf('fail') < 0 && (validationCode === '02' || chargeCode === '02')) {
      return (
        authModel === 'RANDOM_DEBIT' && validationCode === 'RR'
          ? onValidateFailed
          : onRequireValidation
      ).call(context);
    }

    return onValidateFailed.call(context);
  })(options);
}

export default function __handleValidateResponse__(response) {
  const { onBadResponse, onDataResponse, onRequireValidation, onValidateFailed, onValidateSuccessful } = this;

  return __validateResponseHandlerFactory__({
    // maxPingIterations: 0,
    onBadResponse,
    onDataResponse,
    onRequireValidation,
    onValidateFailed,
    onValidateSuccessful
  })(response);
}
